import { Logger } from '~/helpers/logger';
import { useContext } from '@nuxtjs/composition-api';
import DOMPurify from 'isomorphic-dompurify';
import { mapValues } from "lodash-es";

export const useCms = () => {
  const context = useContext();

  const searchCms = async (variables: object) => {
    const mutationVariables = mapValues(variables, (value) => DOMPurify.sanitize(value));

    Logger.debug('useCms/searchCms');

    const data = await context.app.$vsf.$magento.api.searchCms({ mutationVariables });

    Logger.debug('[Result]:', { data });

    return data.data?.['searchCms'];
  };

  return {
    searchCms,
  };
};

export default useCms;
